var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 191,
    viewBox: "0 0 143 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_740_22135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.4 190.3C100.8 190.3 96.7999 189.9 92.2999 189C78.4998 185.4 67.9998 177.2 60.7998 164.3C52.3998 167.6 43.6998 168.3 34.6998 166.5C25.3998 164.4 17.4998 159.6 10.8998 152.1C2.79984 142.8 -0.800156 132 0.0998438 119.7C0.699844 107.1 5.59984 96.7999 14.8998 88.6999C18.1998 85.9999 21.7998 82.8999 25.6998 79.2999C29.2998 75.3999 33.1998 71.4999 37.3998 67.5999C44.5998 60.3999 52.0998 53.0999 59.8998 45.5999C67.9998 38.0999 75.7999 31.4999 83.2999 25.7999C88.3998 21.8999 93.1998 18.4999 97.6998 15.4999C102.5 12.4999 107 9.99989 111.2 7.89989C126.7 0.299894 142 -1.80011 157 1.49989C174.1 6.29989 185.9 17.1999 192.5 34.2999C196.7 46.2999 196.5 58.8999 192.1 72.0999C191.5 73.5999 190.9 75.0999 190.3 76.5999C189.7 78.0999 189 79.6999 188.1 81.4999C198.9 86.5999 206.7 94.9999 211.5 106.7C215.7 118.7 215.2 130.4 210.2 141.8C205.1 152.9 196.6 160.5 184.6 164.7C175.3 168.3 166.8 171.6 159 174.6C151.2 177.3 144.6 179.5 139.2 181.3C136.2 182.5 133.4 183.5 130.7 184.4C128.3 185.3 126.4 186 124.9 186.6C121.9 187.2 118.8 187.9 115.5 188.8C112.2 189.7 108.6 190.1 104.7 190.1L104.4 190.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.021 110.333C120.424 108.946 122.966 100.666 120.7 91.8394C118.434 83.013 112.217 76.9824 106.814 78.3696C101.411 79.7568 98.8684 88.0366 101.135 96.863C103.401 105.689 109.618 111.72 115.021 110.333Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 126.4C121.7 128.2 129.5 133 139.8 132.1C151.7 131 162.2 122.8 167.3 110.8",
    stroke: "#FF6B6B",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_740_22135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialLogo1);
export default __webpack_public_path__ + "static/media/initial-logo1.7e8dc3279f41dd6dc569142d0986fa0d.svg";
export { ForwardRef as ReactComponent };